import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Aksaray Koltuk Yıkama", path: "/fatih/aksaray-koltuk-yikama" },
  { label: "Aksaray Battaniye Yıkama", path: "/fatih/aksaray-battaniye-yikama" },
  { label: "Fındıkzade Koltuk Yıkama", path: "/fatih/findikzade-koltuk-yikama" },
  { label: "Fındıkzade Yorgan Yıkama", path: "/fatih/findikzade-yorgan-yikama" },
  { label: "Çapa Koltuk Yıkama", path: "/fatih/capa-koltuk-yikama" },
  { label: "Çapa Perde Yıkama", path: "/fatih/capa-perde-yikama" },
  { label: "Kocamustafapaşa Koltuk Yıkama", path: "/fatih/kocamustafapasa-koltuk-yikama" },
  { label: "Kocamustafapaşa Kuru Temizleme", path: "/fatih/kocamustafapasa-kuru-temizleme" },
  { label: "Balat Koltuk Yıkama", path: "/fatih/balat-koltuk-yikama" },
  { label: "Balat Yerinde Yıkama", path: "/fatih/balat-yerinde-yikama" },
  { label: "Fatih Merkez Koltuk Yıkama", path: "/fatih/merkez-koltuk-yikama" }
];

const FatihServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          FATİH HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default FatihServiceArea;
